global.BaseUrl = 'https://admin.foodweb-chihuahua.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-chihuahua.ksoftpl.com';

// global.BaseUrl = 'https://foodweb-chihuahua.ksoftpl.com/the-chef/public/api';
// global.AssetsUrl = 'https://foodweb-chihuahua.ksoftpl.com/the-chef/public';